<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Ansprechpartner</div>
{{ contactPerson.title }} {{ contactPerson.firstName }} {{ contactPerson.lastName }}<br />
Geburtsdatum:  {{ contactPerson.birthDate | date }}<br />
Telefonnummer: {{ contactPerson.phoneNumber }}<br />
